export enum GroupMemberType {
    Device = 'DEVICE',
    Group = 'GROUP',
    Individual = 'INDIVIDUAL',
    Phone = 'PHONE'
}
